// extracted by mini-css-extract-plugin
export default {"notification":"_3onop","notification-wrapper":"_1BhSo","notificationWrapper":"_1BhSo","tooltip":"pbkpu","new-tooltip":"MWDbZ","newTooltip":"MWDbZ"};